import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Step } from './common'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'steps'

/**
 * This is the component description.
 */
const Steps = ({
  id,
  className:userClassName,
  style,
  items,
  color,
}) => (
  <div
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
      color && `x-${color}`,
      'grid dense',
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    {
      items.map((item, index) => (
        <Step
          key={item}
          step={item}
          number={index + 1}
        />
      ))
    }
  </div>
)

Steps.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  The steps to iterate
   */
  items:PropTypes.arrayOf(PropTypes.string).isRequired,

  /**
   * The color of the progress bar
   */
  color:PropTypes.string,
}

Steps.defaultProps = {
//
}

export default Steps
